var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscordLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: "100%",
    height: "100%",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "discordLogo"
  }, "Join the Endless Ways discord.") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "discordLogo"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.6,-0.6,0,18.1623,0.0003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30.27,-30.27C-46.989,-30.27 -60.542,-16.717 -60.542,0.001C-60.542,16.719 -46.989,30.27 -30.27,30.27C-13.552,30.27 0.001,16.719 0.001,0.001C0.001,-16.717 -13.552,-30.27 -30.27,-30.27",
    style: {
      fill: "rgb(179,179,179)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6,0,0,0.6,22.3276,14.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.956C-2.214,13.956 -4.033,11.979 -4.033,9.567C-4.033,7.156 -2.254,5.179 0,5.179C2.254,5.179 4.033,7.156 4.033,9.567C4.033,11.979 2.254,13.956 0,13.956M-14.431,13.956C-16.645,13.956 -18.464,11.979 -18.464,9.567C-18.464,7.156 -16.685,5.179 -14.431,5.179C-12.177,5.179 -10.359,7.156 -10.398,9.567C-10.398,11.979 -12.177,13.956 -14.431,13.956M10.359,-5.417C4.665,-9.687 -0.751,-9.569 -0.751,-9.569L-1.305,-8.936C5.417,-6.88 8.54,-3.915 8.54,-3.915C-0.852,-9.062 -11.884,-9.063 -20.994,-5.061C-22.457,-4.389 -23.327,-3.915 -23.327,-3.915C-23.327,-3.915 -20.045,-7.038 -12.929,-9.094L-13.324,-9.569C-13.324,-9.569 -18.74,-9.687 -24.434,-5.417C-24.434,-5.417 -30.127,4.902 -30.127,17.633C-30.127,17.633 -26.806,23.366 -18.068,23.643C-18.068,23.643 -16.606,21.863 -15.419,20.361C-20.441,18.859 -22.338,15.696 -22.338,15.696C-21.757,16.103 -20.798,16.63 -20.717,16.684C-14.044,20.421 -4.565,21.646 3.954,18.068C5.338,17.554 6.88,16.803 8.5,15.735C8.5,15.735 6.524,18.977 1.344,20.44C2.531,21.942 3.954,23.643 3.954,23.643C12.692,23.366 16.052,17.633 16.052,17.633C16.052,4.902 10.359,-5.417 10.359,-5.417",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discordLogo.dca4d057.svg";
export { ForwardRef as ReactComponent };